var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStorage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.08333 13.3025V7.76435C4.08333 7.43436 4.08333 7.26939 4.14691 7.14337C4.20284 7.03248 4.29208 6.94234 4.40184 6.8859C4.52662 6.82166 4.68997 6.82166 5.01667 6.82166H8.98333C9.31006 6.82166 9.47339 6.82166 9.59817 6.8859C9.70795 6.94234 9.79714 7.03248 9.85308 7.14337C9.91667 7.26939 9.91667 7.43436 9.91667 7.76435V13.3025M5.83333 9.17835H8.16667M5.83333 11.535H8.16667M1.75 7.10925V12.3598C1.75 12.6898 1.75 12.8547 1.81358 12.9808C1.86951 13.0917 1.95875 13.1818 2.06851 13.2383C2.19329 13.3025 2.35664 13.3025 2.68333 13.3025H11.3167C11.6434 13.3025 11.8067 13.3025 11.9315 13.2383C12.0413 13.1818 12.1305 13.0917 12.1864 12.9808C12.25 12.8547 12.25 12.6898 12.25 12.3598V7.10925C12.25 6.47664 12.25 6.16032 12.1548 5.88088C12.0706 5.63375 11.9332 5.40855 11.7525 5.2215C11.5482 5.00998 11.2685 4.86775 10.709 4.58329L8.25901 3.33761C7.79748 3.10297 7.56677 2.98565 7.32457 2.93948C7.11007 2.89859 6.88992 2.89859 6.67543 2.93948C6.43323 2.98565 6.20252 3.10297 5.741 3.33761L3.291 4.58329C2.73152 4.86775 2.45177 5.00998 2.24744 5.2215C2.06674 5.40855 1.92935 5.63375 1.84518 5.88088C1.75 6.16032 1.75 6.47665 1.75 7.10925Z",
    stroke: "#254E9C",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorage);
export default __webpack_public_path__ + "static/media/storage.cb31abe71f278918d4a41b1582a478f5.svg";
export { ForwardRef as ReactComponent };